import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./pages/layout/Layout";
import ResetPassword from "./pages/resetpassword/ResetPassword";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import ImportData from "./pages/importdata/ImportData";
import ReferenceData from "./pages/referencedata/ReferenceData";
import DataSelectionNew4 from "./pages/dataselection/DataSelectionNew4";
import DataProcessingNew4 from "./pages/dataprocessing/DataProcessingNew4.jsx";
import History from "./pages/history/History.jsx";
import Reports from "./pages/report/Report";
import ChangePassword from "./pages/changepassword/ChangePassword.jsx";
import DelistedEntity from "./pages/delisted-entity/DelistedEntity.jsx";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/import" element={<ImportData />} />
            <Route path="/reference-data" element={<ReferenceData />} />
            <Route path="/data-selection-new4" element={<DataSelectionNew4/>}/>
            <Route path="/data-processing-new4" element={<DataProcessingNew4 />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/history" element={<History />} />
            <Route path="/delisted-entity" element={<DelistedEntity />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
